

export abstract class Global{

    static userAuth:any = {};
}


// WEBPACK FOOTER //
// ./src/commons/global.ts